import { useMutation, gql } from '@apollo/client';
import {
  CadastrarUnidadeMutation,
  CadastrarUnidadeMutationVariables,
} from './__generated__/CadastrarUnidadeMutation';

const CADASTRAR_UNIDADE_MUTATION = gql`
  mutation CadastrarUnidadeMutation($dsc_nome_unidade: String!) {
    cadastrarUnidade(input: { dsc_nome_unidade: $dsc_nome_unidade }) {
      id_unidade
      dsc_nome_unidade
    }
  }
`;

const useCadastrarUnidadeMutation = () => {
  return useMutation<CadastrarUnidadeMutation, CadastrarUnidadeMutationVariables>(
    CADASTRAR_UNIDADE_MUTATION
  );
};

export { useCadastrarUnidadeMutation };
